export default "__VITE_ASSET__chTv6MIp__"